const testimonies = [
  {
    title: "Precision and Detail",
    content:
      "Their embroidery work showcases incredible precision and attention to detail.  Impressed!",
    name: "Marc Hohorst",
    date: "05-08-2023",
    business: "Univ. of Memphis - Athletic Equipment Manager",
  },
  {
    title: "MSY Nailed It",
    content:
      "The team at MSY Apparel did a great job and met our expectations in every aspect.",
    name: "Andrew Johnson",
    date: "04-16-23",
    business:
      "University of Houston - Assistant Athletic Director for Equipment Operations",
  },
  {
    title: "Flexibility & Quality Impressed",
    content:
      "MSY Apparel impressed me with their remarkable flexibility to meet our request. Their quick turnaround time without compromising quality shows their commitment to their work.",
    name: "Gabe Delatte",
    date: "10-10-23",
    business:
      "Tulane University Assistant Athletic Director - Equipment, Branding, and Licensing",
  },
  {
    title: "Designs Exceed Expectations",
    content:
      "Their designs brought our vision to life and exceeded our expectations. Truly exceptional work!",
    name: "Donald Reed",
    date: "01-27-24",
    business: "FAMU - Athletic Director of Equipment Operations",
  },
  {
    title: "Quality Work and Excellent Customer Service",
    content:
      "I can always expect quality work and excellent customer service when I use MSY Apparel. We’re treated like family and get quality decorations every time.",
    name: "Reid McGee",
    date: "DATE",
    business:
      "Univ. of Southern Miss - Assistant Athletic Director for Equipment Operations",
  },
  {
    title: "Represented in Style with Incredible Turnaround Time",
    content:
      "Thank you MSY Apparel for representing Dragon Dentistry in Style. Not only do they look great but the turnaround time is incredible. 10/10 recommendations!",
    name: "Team Dragon Dentistry",
    date: "02-03-24",
    business: "Dragon Dentistry",
  },
  {
    title: "Professionalism and Timely Delivery",
    content:
      "I would highly recommend MSY Apparel for your business needs. They are very professional and will deliver your products in a timely fashion. The quality of their products are at the highest level.",
    name: "Madonna Golson",
    date: "DATE",
    business: "American Eagle, a division of Bennett Motor Express LLC",
  },
  {
    title: "Exceptional Service and High-Quality Results",
    content:
      "I couldn’t be more pleased with the exceptional service and high-quality results from MSY Apparel. Their top-notch service not only ensured a smooth process but also demonstrated a commitment to customer satisfaction. The attention to detail in their work speaks volumes about the quality they consistently deliver. I highly recommend them for anyone seeking a reliable partner for promotional or apparel needs.",
    name: "Shelly Williams",
    date: "DATE",
    business: "EB President, South Region Hub International",
  },
];
export default testimonies;
